import type { CurrentUser } from "@/lib/auth";
import { userHasGroup, userIsAbrechnung, userIsBuero, userIsManagement, userIsMonteure } from "@/lib/auth";

/** Monteure ohne Büro-, Admin- oder Tester-Rechte bleiben auf der eigenen Materialseite. */
export function isMonteurMaterialOnly(user: CurrentUser | null): boolean {
  if (!user || !userIsMonteure(user)) return false;
  if (userIsBuero(user) || userIsAbrechnung(user) || userIsManagement(user)) return false;
  if (userHasGroup(user, "App-Admins") || userHasGroup(user, "App-Tester")) return false;
  return true;
}

export function materialRequestRoute(user: CurrentUser): string {
  return isMonteurMaterialOnly(user) ? "/materialanforderungen" : "/bestellwesen/materialanforderungen";
}

/** Büro sieht Nachweise unter Dokumente, alle anderen auf der eigenen Seite. */
export function timesheetRoute(user: CurrentUser): string {
  return userIsBuero(user) ? "/dokumente/stundennachweise" : "/stundennachweise";
}

export function completionRoute(user: CurrentUser): string {
  return userIsBuero(user) ? "/dokumente/fertigstellungsmeldungen" : "/stundennachweise";
}
